<script setup lang="ts">
import { MegaphoneIcon } from '@heroicons/vue/24/outline'
import { highlight } from '@/utils/highlight'
import type { OsCampaignResult } from '@/api/omnisearchApi'

const props = defineProps<{
  item: OsCampaignResult
  query: string
}>()

const emit = defineEmits<{ navigate: [] }>()

function handleClick() {
  emit('navigate')
  window.location.href = `/campaigns/${props.item.uuid}/details`
}
</script>

<template>
  <button
    class="w-full flex items-start gap-3 px-3 py-2.5 rounded-lg hover:bg-base-200 transition-colors text-left group cursor-pointer"
    @click="handleClick"
  >
    <span class="mt-0.5 flex-shrink-0 w-8 h-8 rounded-md bg-pink-100 dark:bg-pink-900/30 flex items-center justify-center">
      <MegaphoneIcon class="w-4 h-4 text-pink-600 dark:text-pink-400" />
    </span>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium truncate text-base-content" v-html="highlight(item.name, query)" />
      <span v-if="item.status" class="text-xs text-base-content/60 mt-0.5">{{ item.status }}</span>
    </div>
    <span class="text-xs text-base-content/40 self-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">→</span>
  </button>
</template>
